/**
 * Created By Srijan Shakya
 * Created at 04/03/2020
 * https://marvelapp.com/4g4b5dg/screen/61288626
 */

import React from 'react';
import { Document, Font, Page, pdf, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import slice from 'ramda/src/slice';
import Icon from '@components/@core/Icon';
import PdfHeader from '@components/PdfHeader';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        alignItems: 'stretch',
    },
    listHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '10px',
        paddingTop: '3px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
    },
    mainHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '3px',
        paddingTop: '10px',
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'Roboto',
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        margin: '8px 10px 0px 10px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
        minHeight: '30px',
        maxHeight: '50px',
    },
    pageNumbers: {
        position: 'absolute',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        margin: '10px',
        fontSize: 10,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
    listHeaderTitle: { fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' },
    listItemFont: { fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' },
});

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'normal',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'light',
        },
    ],
});

export const AnniversaryPdf = (props) => {
    const { employees, date } = props;
    const dateStart = date.start.format('MMM-DD');
    const dateEnd = date.end.format('MMM-DD');
    const pageTitle = 'Report - Anniversary Report';
    let pageIndex = 1;

    pdf(
        <Document>
            <Page size="letter" style={styles.container} wrap>
                <PdfHeader header={pageTitle} style={{ paddingTop: '20px' }} date={`${dateStart} - ${dateEnd}`} fixed />
                <View wrap style={{ display: 'flex' }}>
                    <View style={styles.mainHeader} fixed>
                        <View style={{ flex: 4 }}>
                            <Text style={styles.title}>Anniversary Report</Text>
                        </View>
                    </View>
                    <View style={styles.listHeader} fixed>
                        <View style={{ flex: 4 }}>
                            <Text style={styles.listHeaderTitle}>Employee</Text>
                        </View>
                        <View style={{ flex: 2 }}>
                            <Text style={styles.listHeaderTitle}>Company</Text>
                        </View>
                        <View style={{ flex: 2 }}>
                            <Text style={styles.listHeaderTitle}>Departments</Text>
                        </View>
                        <View style={{ flex: 2, textAlign: 'right' }}>
                            <Text style={styles.listHeaderTitle}>Anniversary date</Text>
                        </View>
                        <View style={{ flex: 2, textAlign: 'right', paddingRight: 5 }}>
                            <Text style={styles.listHeaderTitle}>Hire date</Text>
                        </View>
                    </View>
                    {employees.map((employee, index) => {
                        const hireDate = moment(employee.hired_at).format('MMM DD, YY');
                        const anniversaryDate = isNil(employee.anniversary_date) || isEmpty(employee.anniversary_date) ? 'NA' : moment(employee.anniversary_date).format('MMM DD, YY');
                        let pageBreak = false;
                        if (pageIndex == 14) {
                            pageBreak = true;
                            pageIndex = 1;
                        }
                        pageIndex++;
                        return (
                            <View style={styles.listItem} key={index} wrap break={pageBreak}>
                                <View style={{ flex: 4 }}>
                                    <Text style={styles.listItemFont}>{employee.name}</Text>
                                </View>
                                <View style={{ flex: 2 }}>
                                    <Text style={styles.listItemFont}>{employee.company_name}</Text>
                                </View>
                                <View style={{ flex: 2 }}>
                                    <Text style={styles.listItemFont}>{employee.department_name}</Text>
                                </View>
                                <View style={{ flex: 2, textAlign: 'right' }}>
                                    <Text style={styles.listItemFont}>{anniversaryDate}</Text>
                                </View>
                                <View style={{ flex: 2, textAlign: 'right', paddingRight: 5 }}>
                                    <Text style={styles.listItemFont}>{hireDate}</Text>
                                </View>
                            </View>
                        );
                    })}
                </View>
                <Text fixed style={styles.pageNumbers} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
            </Page>
        </Document>
    )
        .toBlob()
        .then((e) => {
            const url = URL.createObjectURL(e);
            window.open(url, '__blank');
        });
};

const PdfIcon = ({ state, props, name }) => {
    const { date, currentPage, perPage } = state;
    const { anniversaryReport } = props;
    const activeEmployee = isEmpty(anniversaryReport.active) ? [] : anniversaryReport.active.employees[0];
    const from = (currentPage - 1) * perPage;
    const to = currentPage * perPage;
    const employees = slice(from, to, activeEmployee);
    const handlePdf = () => {
        AnniversaryPdf({ employees, date });
    };

    if (name) {
        handlePdf();
        return null;
    }
    return <Icon name="fas fa-print" color="#343f4b" size={16} onClick={handlePdf} />;
};

export default PdfIcon;
